'use strict';

//import "../sass/style.scss";

import './polyfills.js';

import './responsive-embeds.js';

import './skip-link-focus-fix.js';

import './components/app.js';

if ( window.addEventListener ) {
	window.document.addEventListener( 'DOMContentLoaded', function() {
		window.document.body.addEventListener( 'contextmenu', function( e ) {
			e.preventDefault();
		} );
	} );
}
